import { FilterField, FilterFieldType } from '../filter';
import * as moment from 'moment';

export class DatePickerFilterField extends FilterField<moment.Moment> {
  readonly type: FilterFieldType = 'date-picker';

  appliedFieldText(): string {
    return `${this.name}: ${new Date(this.value!.toISOString()).toDateString()}`;
  }

  serializeValue(): string {
    return this.value!.toISOString();
  }

  deserializeValue(urlParam: string): moment.Moment {
    return moment.utc(urlParam);
  }
}
